import { POI } from 'taxi-lib';

export default class Order {
    constructor() {
        this.arrived_taxis = []
        this.arrived_taxis_gps = []
        this.accepted_taxis = []
        this.arrived = null;
        this.client_lat = null
        this.client_lng = null
        this.dst_client_lat = null
        this.dst_client_lng = null
        this.created = null
        this.date_time = null
        this.dst_price = null
        this.ended = null;
        this.finished_taxis = []
        this.order_id = null
        this.order_type = "Z"
        this.price = null;
        this.rate = null;
        this.state = null;
        this.taxi_count = 1
        this.taxis_data = null
        this.client_poi = new POI();
        this.dst_client_poi = new POI();
        this.activated_utc = null;
    }

    from_track(data) {
        this.arrived_taxis = data?.arrived_taxis ?? [];
        this.arrived_taxis_gps = data?.arrived_taxis_gps ?? [];
        this.accepted_taxis = data?.accepted_taxis ?? [];
        this.arrived = data?.arrived ?? null;
        this.client_lat = data?.client_lat;
        this.client_lng = data?.client_lng;
        this.dst_client_lat = data?.dst_client_lat;
        this.dst_client_lng = data?.dst_client_lng;
        this.created = data?.created;
        this.date_time = data?.date_time;
        this.dst_price = data?.dst_price;
        this.ended = data?.ended ?? null;
        this.finished_taxis = data?.finished_taxis ?? [];
        this.order_id = data?.order_id;
        this.order_type = data?.order_type;
        this.price = data?.price ?? null;
        this.rate = data?.rate ?? null;
        this.state = data?.state ?? null;
        this.taxi_count = data?.taxi_count;
        this.taxis_data = data?.taxis_data ?? null;
        this.activated_utc = data?.activated_utc ?? null;

        this.client_poi.copy_from_track(data);
        this.dst_client_poi.copy_dst_from_track(data);
    }
}